import { generateAPI } from "../api.generator";

// GET /feedback/mine/support-unread — combined unread support count (chat +
// tickets) for badging the support icon.
export const getSupportUnread = generateAPI<{}, { count: number }>(
  "get",
  "feedback/mine/support-unread"
);
